import React from "react";
import { NavLink, Link } from "react-router-dom";
import { AiOutlineWhatsApp } from "react-icons/ai";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";
import { useGetAllCategoryListQuery } from "../../../utils/api/category/category.api";
import { FiPhoneCall } from "react-icons/fi";
import VersionChecker from "../../../versionChecker/VersionChecker";
import footerLogo from "../../../assets/images/appImages/Logo_Fouta.png";

const WHATSAPP_TEL = "+221 78 270 73 50";
const WHATSAPP_LINK = "https://wa.me/221782707350";

const FrontFooter = () => {
  const { data } = useGetAllCategoryListQuery();
  const date = new Date();

  return (
    <footer className="footer-component">
      <div className="container pt-4 pb-3">
        <div className="row mb-3">
          <div className="col-lg-3 col-md-6 col-12 mb-4">
            <Link to="/" aria-label="Retour à l'accueil">
              <img
                src={footerLogo}
                className="footer-brand-img"
                alt="Fouta Bio"
                width={160}
                height={57}
              />
            </Link>
            <p className="footer-brand-desc">
              <strong>Fouta Bio</strong> — phytothérapie, médecine prophétique,
              Hijama, Roqya et produits naturels sélectionnés avec attention.
            </p>
          </div>

          <div className="col-lg-3 col-md-6 col-12 mb-4">
            <p className="link-footer-title title-footer-deco pb-4">
              Nous contacter
            </p>
            <div className="footer-contact-us-container">
              <div className="footer-contact-us-item mb-3">
                <span className="footer-contact-icon">
                  <AiOutlineWhatsApp style={{ fontSize: 18 }} />
                </span>
                <p className="link-footer mb-0 pb-0">
                  WhatsApp <br />
                  <Link
                    to={WHATSAPP_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-link-underline"
                  >
                    {WHATSAPP_TEL}
                  </Link>
                </p>
              </div>
              <div className="footer-contact-us-item">
                <span className="footer-contact-icon">
                  <FiPhoneCall style={{ fontSize: 18 }} />
                </span>
                <p className="link-footer pb-0 mb-0">
                  Téléphone <br />
                  <Link
                    to="tel:+221782707350"
                    className="footer-link-underline"
                  >
                    {WHATSAPP_TEL}
                  </Link>
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-12 mb-4">
            <p className="link-footer-title title-footer-deco pb-4">
              Nos catégories
            </p>
            <ul className="footer-list">
              {data?.results?.map((item) => (
                <li key={item?.id}>
                  <Link
                    state={{ catgoryId: item?.id }}
                    className="link-footer link-footer-deco trans-0-2"
                    to={`/produits?categorie=${item?.slug}`}
                  >
                    {item?.nom}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-lg-3 col-md-6 col-12 mb-4">
            <p className="link-footer-title title-footer-deco pb-4">
              Liens utiles
            </p>
            <ul className="footer-list mb-4">
              <li>
                <NavLink
                  className="link-footer link-footer-deco trans-0-2"
                  to="/about"
                >
                  Qui sommes-nous ?
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="link-footer link-footer-deco trans-0-2"
                  to="/conditions-generales-de-ventes"
                >
                  Conditions générales de vente
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="link-footer link-footer-deco trans-0-2"
                  to="/politique-de-confidentialite"
                >
                  Politique de confidentialité
                </NavLink>
              </li>
            </ul>
            <div className="footer-social-icons">
              <a
                href="https://www.facebook.com/FoutaBio/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="Facebook"
              >
                <FaFacebookF size={20} />
              </a>

              <a
                href="https://www.instagram.com/invites/contact/?i=1sbjiij4t3srb&utm_content=qwqnqq"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="Instagram"
              >
                <FaInstagram size={20} />
              </a>

              <a
                href="https://www.tiktok.com/@maitre_ventouse?_r=1&_t=ZS-99G3yLbWS5w"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="TikTok"
              >
                <FaTiktok size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-4 pb-1 copyright-container">
          <div className="footer-separator" />
          <div className="pt-3 text-center copyright-text">
            © {date.getFullYear()},{" "}
            <strong>FOUTA BIO</strong>,{" "}
            <span className="copyright-sub">
              Commerce électronique propulsé par{" "}
              <Link
                to="https://easymarket.sn"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link-underline copyright-link"
              >
                Easymarket.sn
              </Link>
            </span>
          </div>
        </div>

        <div className="version-view-container text-end text-white fw-bold">
          {"v" + VersionChecker()}
        </div>
      </div>
    </footer>
  );
};

export default FrontFooter;
